import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage)


import uiButton from '@/components/Button'
import uiDevider from '@/components/Devider'

Vue.component('uiButton', uiButton)
Vue.component('uiDevider', uiDevider)

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')